// === library ===
import React, {
  createRef,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import {
  Platform,
  Image,
  TouchableWithoutFeedback,
  View,
  Dimensions,
} from "react-native";
import {
  HStack,
  KeyboardAvoidingView,
  ScrollView,
  useToast,
} from "native-base";
import { useDispatch, useSelector } from "react-redux";
import { IS_WEB, translate } from "../../locales/translate";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import * as AppActions from "../../actions/AppActions";
import * as CONSTS from "../../../assets/consts";
// === Components ===
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import InputBase from "../../nativeBase-ui/InputBase";
import Text from "../../components_v2/TextFont";
import ToastAlert from "../../nativeBase-ui/ToastAlert";
import { ArButton } from "../../argon-ui";

import DeviceInfoHandler from "../../modules/deviceInfo/DeviceInfoHandler";
import axios from "axios";
import LoginLayout from "./LoginLayout";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import Theme from "../../argon-ui/Theme";
import { persianToEnglishNumber, validationPassword } from "../../util";
import CountDown from "../../components/CountDown";
import ServerInfo from "../../viewModels/ServerInfo";
import CaptchaCode from "../../components_v2/CaptchaCode";

// const IS_WEB = Platform.OS === "web";
// const IS_MOBILE = Platform.OS !== "web";
// const LOGO_KIOSK = 250;
const LOGO_SIZE = 180;
const INPUT_HEIGHT = 45;
const OTP_LENGTH = 4;
interface Props {
  navigation: any;
}
type FormState = {
  phoneNumber: string;
  fullName: string;
  password: string;
  confirmPassword: string;
  captchaCode: string | null;
};
const initialState: FormState = {
  phoneNumber: "",
  fullName: "",
  password: "",
  confirmPassword: "",
  captchaCode: null,
};
type FormValidityState = {
  phoneNumberError: boolean;
  phoneNumberErrorMessage: string;
  fullNameError: boolean;
  fullNameErrorMessage: string;
  passwordError: boolean;
  passwordErrorMessage: string;
  confirmPasswordError: boolean;
  confirmPasswordErrorMessage: string;
  captchaCodeError: boolean;
  captchaCodeErrorMessage: string;
  isFormValid: boolean;
};
const initialValidityState: FormValidityState = {
  phoneNumberError: false,
  phoneNumberErrorMessage: "",
  fullNameError: false,
  fullNameErrorMessage: "",
  passwordError: false,
  passwordErrorMessage: "",
  confirmPasswordError: false,
  confirmPasswordErrorMessage: "",
  captchaCodeError: false,
  captchaCodeErrorMessage: "",
  isFormValid: false,
};
type FormAction = {
  type: string;
  payLoad: string;
};
type FormValidityAction = {
  type: string;
  payLoad: FormState;
};

const formReducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case "UPDATE_PHONE_NUMBER":
      return {
        ...state,
        phoneNumber: action.payLoad,
      };
    case "UPDATE_FULL_NAME":
      return {
        ...state,
        fullName: action.payLoad,
      };
    case "UPDATE_PASSWORD":
      return {
        ...state,
        password: action.payLoad,
      };
    case "UPDATE_PASSWORD_CONFIRM":
      return {
        ...state,
        confirmPassword: action.payLoad,
      };
    case "UPDATE_CAPTCHA_CODE":
      return {
        ...state,
        captchaCode: action.payLoad,
      };
    default:
      return state;
  }
};
const formValidityReducer = (
  state: FormValidityState,
  action: FormValidityAction
): FormValidityState => {
  let isValid: boolean = false;
  let IsRequired: string = "";
  switch (action.type) {
    case "VALIDATE_PHONE_NUMBER":
      isValid = action.payLoad.phoneNumber.length > 10 ? true : false;
      IsRequired =
        action.payLoad.phoneNumber.length == 0
          ? translate("login.errors.EmptyUserName")
          : !isValid
          ? translate("login.errors.InvalidPhoneNumber")
          : "";
      return {
        ...state,
        ...{
          phoneNumberError: !!IsRequired,
          isFormValid:
            isValid &&
            IsRequired == "" &&
            !state.passwordError &&
            !state.confirmPasswordError &&
            !state.captchaCodeError,
          phoneNumberErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_FULL_NAME":
      isValid = action.payLoad.fullName.length > 3 ? true : false;
      IsRequired =
        action.payLoad.fullName.length == 0
          ? translate("login.errors.MinFullName")
          : !isValid
          ? translate("login.errors.EmptyFullName")
          : "";
      return {
        ...state,
        ...{
          fullNameError: !!IsRequired,
          isFormValid:
            isValid &&
            IsRequired == "" &&
            !state.phoneNumberError &&
            !state.confirmPasswordError &&
            !state.passwordError &&
            !state.captchaCodeError,
          fullNameErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_PASSWORD":
      isValid = action.payLoad.password.length > 4 ? true : false;
      IsRequired =
        action.payLoad.password.length == 0
          ? translate("login.errors.requiredPassword")
          : !isValid
          ? translate("login.errors.ShortPassword")
          : !validationPassword(action.payLoad.password)
          ? translate("login.errors.minimumRightCharactersPassword")
          : "";
      return {
        ...state,
        ...{
          passwordError: !!IsRequired,
          isFormValid:
            isValid &&
            IsRequired == "" &&
            !state.phoneNumberError &&
            !state.confirmPasswordError &&
            !state.fullNameError &&
            !state.captchaCodeError,
          passwordErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_PASSWORD_CONFIRM":
      isValid = action.payLoad.confirmPassword === action.payLoad.password;
      IsRequired = !isValid ? translate("login.errors.DisMatchedPassword") : "";
      return {
        ...state,
        ...{
          confirmPasswordError: !!IsRequired,
          isFormValid:
            isValid &&
            IsRequired == "" &&
            !state.phoneNumberError &&
            !state.fullNameError &&
            !state.passwordError &&
            !state.captchaCodeError,
          confirmPasswordErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_CAPTCHA_CODE":
      IsRequired = !action.payLoad.captchaCode
        ? translate("login.errors.captchaCodeIsRequired")
        : "";
      return {
        ...state,
        ...{
          captchaCodeError: !!IsRequired,
          isFormValid:
            IsRequired == "" &&
            !state.phoneNumberError &&
            !state.fullNameError &&
            !state.passwordError &&
            !state.confirmPasswordError,
          captchaCodeErrorMessage: IsRequired,
        },
      };
    default:
      return state;
  }
};

const SignInScreen = (props: Props) => {
  let { navigation } = props;
  const captchaCodeRef = useRef<any>(null);
  const dispatch = useDispatch();
  const appReducer = useSelector((state: any) => state.AppReducer);
  const toast = useToast();

  const [isKioskMode, setIsKioskMode] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [passwordOtp, setPasswordOtp] = useState("");
  const [userId, setUserId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState({
    otpErrorMessage: null,
    otpError: false,
  });
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(100);

  // === Kiosk Mode ===
  // === Kiosk Mode handler  ===
  const KioskMode = () => {
    var devInfo = new DeviceInfoHandler();
    let isKioskModeDevice: boolean = devInfo.isKioskMode();
    setIsKioskMode(isKioskModeDevice);
    dispatch(AppActions.updateKioskMode(isKioskModeDevice));
  };
  // === first Load ===
  useEffect(() => {
    KioskMode();
  }, []);
  // === update Kiosk with change width size ===
  useEffect(() => {
    Dimensions.addEventListener("change", () => KioskMode());

    return () => {
      Dimensions.removeEventListener("change", () => KioskMode());
    };
  }, []);

  const handleOnLogin = async (
    serverUrl: string,
    serverId: string,
    cloudServerId: string | null,
    token: string,
    userFullName: string,
    userId: string,
    setFormData?: any
  ) => {
    setSpinnerLoading(true);
    // === create and update serverInfo ===
    let publicAddress = null;
    let localAddress = null;
    if (cloudServerId) {
      const servers = await SecureStore.Servers.getServers();
      if (servers && servers.length !== 0) {
        const findServer = servers.find(
          (server: ServerInfo) => server.serverId === cloudServerId
        );
        if (findServer) {
          publicAddress = findServer.publicAddress;
        }
      } else {
        publicAddress = serverUrl;
      }
      localAddress = serverUrl;
    } else {
      publicAddress = serverUrl;
    }
    const serverInfo = {
      serverId,
      publicAddress,
      localAddress,
      accessToken: token,
      userFullName,
      userId,
      ports: CONSTS.DEFAULT_PORTS_BRAND,
    };
    SecureStore.Servers.updateServer(serverInfo);
    SecureStore.setItemAsync(CONSTS.USER_ID, userId);
    SecureStore.setItemAsync(CONSTS.ACCESS_TOKEN, token);

    // === force init  ===
    // const currentServer = await SecureStore.Servers.getCurrentServer();
    dispatch(AppActions.addServer(serverInfo));
    dispatch(AppActions.updateCurrentServer(serverInfo));

    dispatch(AppActions.ForceInit(token, ""));
    navigation.replace("Home");
    if (setFormData) {
      setFormData({
        type: "UPDATE_FULL_NAME",
        payLoad: "",
      });
      setFormData({
        type: "UPDATE_PHONE_NUMBER",
        payLoad: "",
      });
      setFormData({ type: "UPDATE_PASSWORD", payLoad: "" });
      setFormData({
        type: "UPDATE_PASSWORD_CONFIRM",
        payLoad: "",
      });
    }
  };
  const sendOtpHandler = (
    values: FormState,
    captchaId: string,
    setFormData: any
  ) => {
    // === todo send captcha ===
    const { fullName, phoneNumber, password, captchaCode } = values;
    const username = persianToEnglishNumber(phoneNumber);
    setPhoneNumber(username);
    setPasswordOtp(password);
    setSpinnerLoading(true);
    // === serverUrl ===
    var serverUrl = appReducer.serverUrl;
    if (!serverUrl.endsWith("/")) {
      serverUrl = serverUrl + "/";
    }
    axios
      .post(
        `${serverUrl}Auth/Register`,
        {
          fullName,
          username,
          password,
          captchaCode,
          captchaId,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        const {
          access_token,
          userFullName,
          userId,
          serverId,
          cloudServerId,
          authenticated,
          errors,
          otpRequired,
        } = res.data;
        setSpinnerLoading(false);
        if (authenticated) {
          if (res.status == 200) {
            setUserId(userId);
            // === check otp ===
            if (otpRequired) {
              setStep(2);
            } else {
              toast.show({
                render: () => {
                  return (
                    <RenderToastAlert
                      message={translate("login.successMessage")}
                      status="success"
                    />
                  );
                },
              });
              setTimeout(() => {
                handleOnLogin(
                  serverUrl,
                  serverId,
                  cloudServerId,
                  access_token,
                  userFullName,
                  userId,
                  setFormData
                );
              }, 500);
            }
          } else {
            captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
            toast.show({
              render: () => {
                return (
                  <RenderToastAlert
                    message={translate(`login.errors.undefinedError`)}
                  />
                );
              },
            });
            setSpinnerLoading(false);
          }
        } else {
          captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
          toast.show({
            render: () => {
              return (
                <RenderToastAlert
                  message={translate(`login.errors.${errors[0]}`)}
                />
              );
            },
          });
        }
      })
      .catch((error) => {
        console.log("login error", error);
        toast.show({
          render: () => {
            return (
              <RenderToastAlert
                message={translate(`login.errors.undefinedError`)}
              />
            );
          },
        });
        setSpinnerLoading(false);
      });
  };
  const createAccountHandler = (
    _otp: string,
    phoneNumber: string,
    captcha: { captchaId: string; captchaCode: string }
  ) => {
    var serverUrl = appReducer?.serverUrl;
    if (!serverUrl.endsWith("/")) {
      serverUrl = serverUrl + "/";
    }
    try {
      if (
        true
        // (_otp.length !== 0, phoneNumber.length !== 0, passwordOtp.length !== 0)
      ) {
        setSpinnerLoading(true);
        axios
          .post(
            `${serverUrl}Auth/VerifyRegisteration`,
            {
              token: persianToEnglishNumber(otp),
              userName: phoneNumber,
              password: passwordOtp,
              userId,
              captchaId: captcha.captchaId,
              captchaCode: captcha.captchaCode,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            setSpinnerLoading(false);
            const {
              access_token,
              userFullName,
              userId,
              serverId,
              cloudServerId,
              authenticated,
              errors,
            } = res.data;
            if (authenticated) {
              toast.show({
                render: () => {
                  return (
                    <RenderToastAlert
                      message={translate("login.successMessage")}
                      status="success"
                    />
                  );
                },
              });
              setTimeout(() => {
                handleOnLogin(
                  serverUrl,
                  serverId,
                  cloudServerId,
                  access_token,
                  userFullName,
                  userId
                );
              }, 500);
            } else {
              toast.show({
                render: () => {
                  return (
                    <RenderToastAlert
                      message={translate(`login.errors.${errors[0]}`)}
                    />
                  );
                },
              });
            }
          });
      }
    } catch (error) {
      console.log("error otp handler", error);
      setSpinnerLoading(false);
    }
  };
  const renderLayout = () => {
    switch (step) {
      case 1:
        return (
          <RenderSignInLayout
            captchaCodeRef={captchaCodeRef}
            spinnerLoading={spinnerLoading}
            navigation={navigation}
            phoneNumber={phoneNumber}
            createAccountHandler={(
              values: FormState,
              captchaId: string,
              setFormData: any
            ) => {
              sendOtpHandler(values, captchaId, setFormData);
            }}
          />
        );
      case 2:
        return (
          <RenderOtp
            captchaCodeRef={captchaCodeRef}
            phoneNumber={phoneNumber}
            setOtp={setOtp}
            otp={otp}
            otpError={otpError}
            setOtpError={setOtpError}
            loading={spinnerLoading}
            timer={timer}
            setTimer={setTimer}
            setStep={setStep}
            createAccountHandler={(
              opt: string,
              captcha: {
                captchaId: string;
                captchaCode: string;
              }
            ) => {
              createAccountHandler(opt, phoneNumber, captcha);
            }}
          />
        );

      default:
        break;
    }
  };
  return (
    <LoginLayout>
      <KeyboardAvoidingView
        justifyContent="center"
        h="100%"
        w={isKioskMode ? "50%" : "100%"}
        behavior={Platform.OS === "ios" ? "padding" : "height"}
      >
        <ScrollView
          contentContainerStyle={{ flex: 1, justifyContent: "center" }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
            }}
          >
            {!isKioskMode && (
              <Image
                source={CONSTS?.BRANDING?.LOGO_TYPE}
                // width={LOGO_SIZE}
                // height={LOGO_SIZE}
                // style={styles.logo}
                style={{
                  width: LOGO_SIZE,
                  height: 50,
                  resizeMode: "contain",
                }}
              />
            )}
            <View
              style={{
                paddingVertical: 10,
                width: "90%",
                justifyContent: "center",
                maxWidth: isKioskMode ? "100%" : "90%",
              }}
            >
              <HStack
                justifyContent="space-between"
                space="2"
                alignItems="center"
              >
                <Text
                  style={{
                    fontSize: 18,
                    fontWeight: "600",
                    color: Theme.COLORS.MUTED,
                  }}
                >
                  {translate("login.goToSignin")}
                </Text>
                <ArButton
                  variant="ghost"
                  style={{ marginBottom: 0 }}
                  onPress={() => navigation.replace("Login")}
                >
                  {translate("login.loginHeading")}
                </ArButton>
              </HStack>
              <View
                style={{
                  minHeight: "60%",
                }}
              >
                {renderLayout()}
              </View>
            </View>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </LoginLayout>
  );
};

export default SignInScreen;

// === Render Sign In Layout  ===
const RenderSignInLayout = (props: any) => {
  let { createAccountHandler, spinnerLoading, captchaCodeRef } = props;
  const [captchaId, setCaptchaId] = useState<string | null>(null);
  const [validCaptchaCode, setValidCaptchaCode] = useState<boolean>(false);
  // === Form Validation ===
  const [formData, setFormData] = useReducer(formReducer, initialState);
  const [formValidityData, setFormValidityData] = useReducer(
    formValidityReducer,
    initialValidityState
  );
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  return (
    <>
      {/* === Phone Number === */}
      <InputBase
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        showSubInput={true}
        keyboardType="numeric"
        isInvalid={formValidityData.phoneNumberError}
        errorMessage={formValidityData.phoneNumberErrorMessage}
        value={formData.phoneNumber}
        onChangeText={(phoneNumber: string) =>
          setFormData({
            type: "UPDATE_PHONE_NUMBER",
            payLoad: phoneNumber,
          })
        }
        placeholder={translate("login.phoneNumber")}
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_PHONE_NUMBER",
            payLoad: formData,
          })
        }
        icon={faCharCodes.faPhoneAlt}
      />

      <InputBase
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        showSubInput={true}
        isInvalid={formValidityData.fullNameError}
        errorMessage={formValidityData.fullNameErrorMessage}
        value={formData.fullName}
        placeholder={translate("login.fullName")}
        onChangeText={(fullName: string) =>
          setFormData({
            type: "UPDATE_FULL_NAME",
            payLoad: fullName,
          })
        }
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_FULL_NAME",
            payLoad: formData,
          })
        }
        icon={faCharCodes.faUserAlt}
      />
      {/* === Password === */}
      <InputBase
        // showSubInput={true}
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        label={translate("login.errors.minimumRightCharactersPassword")}
        labelStyle={{
          fontSize: 10,
          padding: 0,
          marginTop: 5,
          color: formValidityData.passwordError
            ? Theme.COLORS.ERROR
            : Theme.COLORS.GRAY_DARK,
        }}
        isInvalid={formValidityData.passwordError}
        // errorMessage={formValidityData.passwordErrorMessage}
        value={formData.password}
        placeholder={translate("login.password")}
        onChangeText={(password: string) =>
          setFormData({ type: "UPDATE_PASSWORD", payLoad: password })
        }
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_PASSWORD",
            payLoad: formData,
          })
        }
        icon={faCharCodes.faLockAlt}
        secureTextEntry={!showPassword}
        iconLeft={
          <TouchableWithoutFeedback
            onPress={() => setShowPassword(!showPassword)}
          >
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                paddingHorizontal: 14,
              }}
            >
              <FontAwesomeIcon
                icon={showPassword ? faCharCodes.faEyeSlash : faCharCodes.faEye}
                color={Theme.COLORS.MUTED}
              />
            </View>
          </TouchableWithoutFeedback>
        }
      />
      {/* === Confirm Password === */}
      <InputBase
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        showSubInput={true}
        isInvalid={formValidityData.confirmPasswordError}
        errorMessage={formValidityData.confirmPasswordErrorMessage}
        value={formData.confirmPassword}
        placeholder={translate("login.confirmPassword")}
        onChangeText={(passwordConfirm: string) =>
          setFormData({
            type: "UPDATE_PASSWORD_CONFIRM",
            payLoad: passwordConfirm,
          })
        }
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_PASSWORD_CONFIRM",
            payLoad: formData,
          })
        }
        secureTextEntry={!showPasswordConfirm}
        icon={faCharCodes.faLockAlt}
        iconLeft={
          <TouchableWithoutFeedback
            onPress={() => setShowPasswordConfirm(!showPasswordConfirm)}
          >
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                paddingHorizontal: 14,
              }}
            >
              <FontAwesomeIcon
                icon={
                  showPasswordConfirm
                    ? faCharCodes.faEyeSlash
                    : faCharCodes.faEye
                }
                color={Theme.COLORS.MUTED}
              />
            </View>
          </TouchableWithoutFeedback>
        }
      />
      {/* === Captcha Code === */}
      <CaptchaCode
        ref={captchaCodeRef}
        setValidCaptchaCode={setValidCaptchaCode}
        setCaptchaId={(captchaId) => {
          setCaptchaId(captchaId);
        }}
        captchaId={captchaId}
        captchaCode={formData.captchaCode}
        setCaptchaCode={(code) => {
          setFormData({ type: "UPDATE_CAPTCHA_CODE", payLoad: code });
        }}
        onBlur={() => {
          setFormValidityData({
            type: "VALIDATE_CAPTCHA_CODE",
            payLoad: formData,
          });
        }}
        errorMessage={formValidityData.captchaCodeErrorMessage}
      />
      {/* === Submit Btn === */}
      <View style={{ marginTop: 10 }}>
        <ArButton
          isLoading={spinnerLoading}
          onPress={() => {
            setFormValidityData({
              type: "VALIDATE_PHONE_NUMBER",
              payLoad: formData,
            });
            setFormValidityData({
              type: "VALIDATE_FULL_NAME",
              payLoad: formData,
            });
            setFormValidityData({
              type: "VALIDATE_PASSWORD",
              payLoad: formData,
            });
            setFormValidityData({
              type: "VALIDATE_PASSWORD_CONFIRM",
              payLoad: formData,
            });
            validCaptchaCode &&
              setFormValidityData({
                type: "VALIDATE_CAPTCHA_CODE",
                payLoad: formData,
              });

            if (
              formData.fullName.length > 3 &&
              formData.phoneNumber.length > 10 &&
              formData.password.length > 4 &&
              validationPassword(formData.password) &&
              formData.password === formData.confirmPassword &&
              (validCaptchaCode
                ? formData.captchaCode && formData.captchaCode?.length !== 0
                : true)
            ) {
              formValidityData.isFormValid &&
                createAccountHandler(formData, captchaId, setFormData);
            }
          }}
        >
          {translate("login.createAccount")}
        </ArButton>
      </View>
    </>
  );
};

const RenderOtp = (props: any) => {
  const inputRef = createRef<any>();
  let {
    createAccountHandler,
    setOtp,
    otp,
    loading,
    phoneNumber,
    otpError,
    setOtpError,
    timer,
    setTimer,
    setStep,
    captchaCodeRef,
  } = props;
  const [captchaId, setCaptchaId] = useState<string | null>(null);
  const [captchaCode, setCaptchaCode] = useState<string>("");
  const [validCaptchaCode, setValidCaptchaCode] = useState<boolean>(false);
  const [otpErrorCaptcha, setOtpErrorCaptcha] = useState({
    otpErrorMessage: "",
    otpError: false,
  });
  const onChangeHandler = (otp: string) => {
    resetError();
    setOtp(otp);
  };
  const resetError = () => {
    setOtpError({
      otpErrorMessage: null,
      otpError: false,
    });
  };
  // === Form Validation ===
  const validation = (): boolean => {
    let isValid = true;
    if (otp.length === 0) {
      isValid = false;
      setOtpError({
        otpErrorMessage: translate("login.errors.OtpRequired"),
        otpError: true,
      });
    }
    if (validCaptchaCode && captchaCode.length === 0) {
      isValid = false;
      setOtpErrorCaptcha({
        otpErrorMessage: translate("login.errors.captchaCodeIsRequired"),
        otpError: true,
      });
    }
    return isValid;
  };
  const submitHandler = () => {
    validation() && createAccountHandler(otp, { captchaId, captchaCode });
  };
  // === focus first ===
  useEffect(() => {
    // if (otp.length === OTP_LENGTH) {
    inputRef.current?.focus();
    // }
  }, []);
  // === submit for time otp length => 4  ===
  // useEffect(() => {
  //   if (otp.length === OTP_LENGTH) {
  //     submitHandler();
  //   }
  // }, [otp]);
  return (
    <>
      {/* === Timer === */}
      {timer > 0 && (
        <CountDown
          until={timer}
          size={20}
          timeToShow={["M", "S"]}
          style={{
            direction: Platform.OS == "web" ? "rtl" : "ltr",

            // marginVertical: -10,
          }}
          digitStyle={{
            backgroundColor: "#FFFFFF00",
            paddingTop: IS_WEB ? 10 : 25,
          }}
          onFinish={() => {
            setTimeout(() => {
              setTimer(0);
              setStep(1);
              setOtp("");
              captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
            }, 1000);
          }}
          timeLabelStyle={{ color: Theme.COLORS.MUTED }}
          timeLabels={{
            // d: translate("timer.days"),
            // h: translate("timer.hours"),
            m: " ",
            s: " ",
          }}
          showSeparator
        />
      )}
      <Text
        style={{
          marginBottom: 10,
          fontSize: 12,
          color: Theme.COLORS.GRAY_DARK,
        }}
      >
        {translate("login.OtpMessage", { phoneNumber })}
      </Text>
      {/* === Otp === */}
      <InputBase
        ref={inputRef}
        inputStyle={{ height: INPUT_HEIGHT, textAlign: "center", fontSize: 12 }}
        showSubInput={true}
        keyboardType="numeric"
        // maxLength={OTP_LENGTH}
        isInvalid={otpError.otpError}
        errorMessage={otpError.otpErrorMessage}
        placeholder={translate("login.otpSms")}
        value={otp}
        onChangeText={(otp: string) => onChangeHandler(otp)}
        // icon={faCharCodes.faPhoneAlt}
      />
      {/* === Captcha Code === */}
      <CaptchaCode
        ref={captchaCodeRef}
        setValidCaptchaCode={setValidCaptchaCode}
        setCaptchaId={(captchaId) => {
          setCaptchaId(captchaId);
        }}
        captchaId={captchaId}
        captchaCode={captchaCode}
        setCaptchaCode={(code) => {
          setCaptchaCode(code);
          setOtpErrorCaptcha({
            otpErrorMessage: "",
            otpError: false,
          });
        }}
        errorMessage={otpErrorCaptcha.otpErrorMessage}
      />
      {/* === Submit Btn === */}
      <ArButton
        style={{ marginTop: 15 }}
        isLoading={loading}
        onPress={submitHandler}
      >
        {translate("login.Otp")}
      </ArButton>
    </>
  );
};

interface ToastType {
  message: string;
  status?: string;
}
const RenderToastAlert = (props: ToastType) => {
  const { message, status = "error" } = props;
  // const {message: string, status = "error"=props
  return <ToastAlert title={message} variant="subtle" status={status} />;
};
